import { z } from 'zod';
import { CAMERA_PLATFORM_IDS, normalizeCameraPlatform } from './camera-platform.js';

/** New output uses UAV; older saved projects and render configurations remain readable. */
export const CameraPlatformSchema = z.enum([...CAMERA_PLATFORM_IDS, 'overview']).transform(value => normalizeCameraPlatform(value)!);
